import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-error-message',
	templateUrl: './error-message.component.html',
	standalone: false
})
export class ErrorMessageComponent {
	@Input() errors: string[] = [];
}